// Canonical source for all docs.p0.dev URLs.
// Import from here instead of hardcoding URLs in components.

export const DOCS_URLS = {
  // General
  BASE: "https://docs.p0.dev",
  QUICK_START: "https://docs.p0.dev/getting-started/quick-start",
  QUICK_START_CONFIGURE_APPROVER:
    "https://docs.p0.dev/getting-started/quick-start#configure-an-access-approver",
  ACCESS_CONTROL: "https://docs.p0.dev/p0-management/role-based-access-control",

  // Just-in-time access
  JIT_BASE: "https://docs.p0.dev/what-is-p0/just-in-time-access",
  JIT_REQUESTING:
    "https://docs.p0.dev/orchestration/just-in-time-access/requesting-access",
  JIT_ROUTING:
    "https://docs.p0.dev/orchestration/just-in-time-access/request-routing",
  JIT_ROUTING_API: "https://docs.p0.dev/just-in-time-access/request-routing",
  JIT_CUSTOM_NOTIFIER:
    "https://docs.p0.dev/integrations/notifier-integrations/custom-notifier",

  // IAM assessment
  IAM_ASSESSMENT: "https://docs.p0.dev/what-is-p0/iam-assessment",
  IAM_ASSESSMENT_RUNNING:
    "https://docs.p0.dev/iam-assessment/running-an-iam-assessment",
  IAM_ASSESSMENT_QUERY_SEARCH:
    "https://docs.p0.dev/iam-assessment/query-search",
  IAM_ASSESSMENT_CREATE_ENVIRONMENT:
    "https://docs.p0.dev/environments/creating-an-environment#install-for-iam-data-collection",

  // AWS
  AWS_INSTALL: "https://docs.p0.dev/integrations/resource-integrations/aws",
  AWS_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/aws/requesting-access",
  AWS_IAM_WRITE:
    "https://docs.p0.dev/integrations/resource-integrations/aws#setting-up-aws-iam-management",
  AWS_INVENTORY:
    "https://docs.p0.dev/integrations/resource-integrations/aws#setting-up-aws-resource-inventory",
  AWS_ACCESS_LOGS:
    "https://docs.p0.dev/orchestration/just-in-time-access/session-recording/aws",
  AWS_FUNCTION_CALLER:
    "https://docs.p0.dev/integrations/resource-integrations/aws/function-invocation",
  AWS_RDS_SECURITY_PERIMETER:
    "https://docs.p0.dev/integrations/resource-integrations/postgresql/installing-an-rds-database",

  // Google Cloud
  GCLOUD_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud",
  GCLOUD_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud/requesting-access",
  GCLOUD_SECURITY_PERIMETER:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud/security-perimeter",
  GCLOUD_FUNCTION_CALLER:
    "https://docs.p0.dev/integrations/resource-integrations/google-cloud/cloud-run-invocation",

  // Azure
  AZURE_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure",
  AZURE_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure/requesting-access",
  AZURE_APP:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure#step-1-install-the-azure-app-registration",
  AZURE_IAM_WRITE:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure#install-iam-management-just-in-time-access",
  AZURE_BASTION_HOST:
    "https://docs.p0.dev/integrations/resource-integrations/microsoft-azure#configure-ssh-access-control-via-bastion",

  // GitHub
  GITHUB_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/github",
  GITHUB_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/github/requesting-access",

  // Kubernetes
  K8S_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/kubernetes",
  K8S_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/kubernetes/requesting-access",

  // Custom resource
  CUSTOM_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/custom-resource",
  CUSTOM_REQUEST:
    "https://docs.p0.dev/integrations/resource-integrations/custom-resource/installing-a-custom-resource-integration",

  // SSH / Self-hosted / Tailscale / Zscaler
  SSH_INSTALL: "https://docs.p0.dev/integrations/resource-integrations/ssh",
  SELF_HOSTED_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/ssh/self-hosted",
  TAILSCALE_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/tailscale",
  ZSCALER_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/zscaler",

  // Database
  SNOWFLAKE_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/snowflake",
  POSTGRES_INSTALL:
    "https://docs.p0.dev/integrations/resource-integrations/postgresql",

  // Notifiers
  SLACK_INSTALL: "https://docs.p0.dev/integrations/notifier-integrations/slack",
  TEAMS_INSTALL:
    "https://docs.p0.dev/integrations/notifier-integrations/microsoft-teams",
  WEBEX_INSTALL: "https://docs.p0.dev/integrations/notifier-integrations/webex",
  AWS_LAMBDA_NOTIFIER_INSTALL:
    "https://docs.p0.dev/integrations/notifier-integrations/custom-notifiers/aws-lambda-notifier",
  EMAIL_INSTALL: "https://docs.p0.dev/integrations/notifier-integrations/email",

  // Directories
  GOOGLE_WORKSPACE_INSTALL:
    "https://docs.p0.dev/integrations/directory-integrations/google-workspace",
  ENTRA_ID_LEGACY_INSTALL:
    "https://docs.p0.dev/integrations/directory-integrations/microsoft-entra-id-legacy",
  ENTRA_ID_INSTALL:
    "https://docs.p0.dev/integrations/directory-integrations/microsoft-entra-id",
  OKTA_INSTALL: "https://docs.p0.dev/integrations/directory-integrations/okta",
  OKTA_GROUP_ASSIGNMENT:
    "https://docs.p0.dev/integrations/directory-integrations/okta#configure-group-management",

  // Approvers
  PAGERDUTY_INSTALL:
    "https://docs.p0.dev/integrations/approval-integrations/pagerduty",
  INCIDENTIO_INSTALL:
    "https://docs.p0.dev/integrations/approval-integrations/incidentio",

  // Trackers
  JIRA_INSTALL: "https://docs.p0.dev/tracker-integrations/jira",

  // SIEM
  SPLUNK_INSTALL:
    "https://docs.p0.dev/integrations/siem-integrations/splunk-hec-setup",
  DATADOG_INSTALL:
    "https://docs.p0.dev/integrations/siem-integrations/datadog-setup",
} as const;

/** Component-level documentation URLs, keyed by `${integration}/${component}` */
export const COMPONENT_DOCS_URLS: Record<string, string> = {
  // AWS
  "aws/iam-write": DOCS_URLS.AWS_IAM_WRITE,
  "aws/iam-assessment": DOCS_URLS.IAM_ASSESSMENT_CREATE_ENVIRONMENT,
  "aws/inventory": DOCS_URLS.AWS_INVENTORY,
  "aws/access-logs": DOCS_URLS.AWS_ACCESS_LOGS,
  "aws/function-caller": DOCS_URLS.AWS_FUNCTION_CALLER,
  "aws/rds-security-perimeter": DOCS_URLS.AWS_RDS_SECURITY_PERIMETER,

  // Google Cloud
  "gcloud/iam-write": DOCS_URLS.GCLOUD_INSTALL,
  "gcloud/iam-assessment": DOCS_URLS.IAM_ASSESSMENT_CREATE_ENVIRONMENT,
  "gcloud/iam-write-security-perimeter": DOCS_URLS.GCLOUD_SECURITY_PERIMETER,
  "gcloud/function-caller": DOCS_URLS.GCLOUD_FUNCTION_CALLER,

  // Azure
  "azure/azure-app": DOCS_URLS.AZURE_APP,
  "azure/iam-write": DOCS_URLS.AZURE_IAM_WRITE,
  "azure/bastion-host": DOCS_URLS.AZURE_BASTION_HOST,

  // Kubernetes
  "k8s/iam-write": DOCS_URLS.K8S_INSTALL,

  // PostgreSQL
  "pg/access-management": DOCS_URLS.POSTGRES_INSTALL,

  // Snowflake
  "snowflake/iam-write": DOCS_URLS.SNOWFLAKE_INSTALL,

  // SSH
  "ssh/iam-write": DOCS_URLS.SSH_INSTALL,

  // Self-hosted
  "self-hosted/iam-write": DOCS_URLS.SELF_HOSTED_INSTALL,

  // Tailscale
  "tailscale/iam-write": DOCS_URLS.TAILSCALE_INSTALL,

  // Okta
  "okta/listing": DOCS_URLS.OKTA_INSTALL,
  "okta/group-assignment": DOCS_URLS.OKTA_GROUP_ASSIGNMENT,

  // Entra ID
  "entra-id/iam-write": DOCS_URLS.ENTRA_ID_INSTALL,
  "azure-ad/iam-write": DOCS_URLS.ENTRA_ID_LEGACY_INSTALL,

  // Splunk
  "splunk/audit-log": DOCS_URLS.SPLUNK_INSTALL,
  "datadog/audit-log": DOCS_URLS.DATADOG_INSTALL,

  // Custom
  "custom/iam-write": DOCS_URLS.CUSTOM_INSTALL,

  // GitHub
  "github/iam-write": DOCS_URLS.GITHUB_INSTALL,

  // AWS Lambda Notifier
  "aws-lambda-notifier/notify": DOCS_URLS.AWS_LAMBDA_NOTIFIER_INSTALL,
};
